import React from 'react';
import { Select } from './UI';
import {
  OpenAIModel,
  ClaudeModel,
  getModelDisplayName,
  AIModel,
  DeepSeekModel,
  GeminiModel,
} from '../types/AIModels';

interface ModelSelectorProps {
  model: AIModel;
  onChange: (model: AIModel) => void;
}

const ModelSelector: React.FC<ModelSelectorProps> = ({ model, onChange }) => {
  // Generate options by combining all models into a single array and mapping them
  const allModelValues = [
    ...Object.values(OpenAIModel),
    ...Object.values(ClaudeModel),
    ...Object.values(DeepSeekModel),
    ...Object.values(GeminiModel),
  ];

  const options = [
    { value: '', label: 'Auto' },
    ...allModelValues.map((modelValue) => ({
      value: modelValue,
      label: getModelDisplayName(modelValue),
    })),
  ];

  const handleChange = (value: AIModel | undefined) => {
    if (value !== undefined) {
      onChange(value);
    }
  };

  return <Select<AIModel> label="Model" options={options} value={model} onChange={handleChange} />;
};

export default ModelSelector;
